import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
let hashLib = require('object-hash');
import { defaultBaseSettings } from "./defaultWebappSettings";
import _ from 'lodash';

export default new Vuex.Store({
    strict: false,
    state: {
        applicationVersion: process.env.VUE_APP_VERSION || '0',
        expressMode: (new URLSearchParams(window.location.search)).has('express'),
        expressReady: false,
        authenticating: false,
        user: null,
        userImage: null,
        // Modifying the kickoff int will trigger a watcher in app.vue which force logs the user out
        kickoff: 0,
        batchConfig: null,

        audioFiles: [],
        audioPlayQueue: [],
        audioPlayData: null,
        connectionInfo: {},

        messagingDrawerOpen: false,
        messagingDrawerActiveContact: null,

        validationFuncs: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            requiredIf: (value, ifSet, fieldName) => ((value || value === 0) ? true : false) || !ifSet || `${fieldName} is required`,
            requiredNotNullOrUndefined: (value, fieldName) => (value !== null && value !== undefined) || `${fieldName} is required`,
            requiredList: (value, fieldName) => (value != null && value.length !== 0) || `${fieldName} is required`,
            positiveInteger: (value, fieldName) => (value != null && (value.toString().indexOf('.') === -1) && (value.toString().indexOf('e') === -1) && (value.toString().indexOf('-') === -1) && parseInt(Number(value)) > 0) || `${fieldName} must be a positive integer`,
            intRange: (value, min, max, fieldName) => ((value == null || value == "") || (Number.isInteger(Number(value)) && parseInt(value) >= min && parseInt(value) <= max)) || `${fieldName} must be an integer between ${min} and ${max}`,
            floatRange: (value, min, max, fieldName) => ((value == null || value == "") || (parseFloat(value) >= min && parseFloat(value) <= max)) || `${fieldName} must be between ${min} and ${max}`,
            positiveFloat: (value, fieldName) => ((value == null || value == "") || (parseFloat(value) > 0)) || `${fieldName} must be positive`,
            positiveFloatRequired: (value, fieldName) => ((parseFloat(value) > 0)) || `${fieldName} must be positive`,
            allRequiredIfAnyHasValue: (fieldsObjs) => (fieldsObjs.every(fObj => !fObj.value) || fieldsObjs.every(fObj => !!fObj.value)) || `(${fieldsObjs.map(fObj => fObj.name).toString(', ')}) required if any have values`,
            nonNegInteger: (value) => ((value.toString().indexOf('.') === -1) && (value.toString().indexOf('e') === -1) && (value.toString().indexOf('-') === -1) && parseInt(Number(value)) > -1) || `Value must be a non-negative integer`,
            validURL: (value) => ((/^(?:https?|ftp):\/\/(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z]{2,6}\.?|[A-Z0-9-]{2,}\.?)|localhost|d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/\S*)?$/i.test(value) || !value) || "Invalid URL"),
            maxFileSize: (file, maxSize, maxSizeStr) => (!file || file.size <= maxSize || `Max file size is ${maxSizeStr}`),
            timeLimited: (enabled, start, end, message) => (!enabled || (!!start && !!end && (TELSA.moment(start) < TELSA.moment(end))) || message),
            ipAddr: (value) => ((/^(?=\d+\.\d+\.\d+\.\d+$)(?:(?:25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\.?){4}$/.test(value)) || 'Invalid IP Address'),
            noDuplicates: (value, existingList) => (!existingList || !value || !existingList.includes(value) || `${value} already exists`),
            noDuplicatesCaseInsensitive: (value, existingList) => (!existingList || !value || !existingList.some(x => x.toLowerCase() == value.toLowerCase()) || `${value} already exists`),
            email: (value) => ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) || !value) || "Invalid email address"),
            cidr: (value) => ( /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[1-2]?[0-9])$/.test(value) || "Invalid Network")
        },
        formatDate: (v, f) => (TELSA.moment(v).format(f)),

        confirmModal: {
            show: false,
            type: '',
            title: '',
            message: '',
            confirmAction: null,
            hideCancel: false,
            cancelAction: function(){}
        },
        fullscreenElement: '#telsasoft-application',
        isDirty: false,
        lock: null,
        secondaryLocks: [],

        broadcastMessage: {
            time: null,
            from: null,
            message: null,
            show: false,
            messageHistory: []
        },

        telsasoftAbout: {
            show: false
        },

        pagingClientMessage: {
            time: null,
            message: null,
            show: false,
        },

        wikiHelp: {
            domain: 'https://wiki.telsasoft.com/',
            route: '',
            show: false,
            accessKey: 'tt84rshkrem255'
        },
        tutorialsAccessKey: 'kx546*113',

        webRtc: {
            contact: null,
            outgoing: false,
            incoming: false,
            show: false,
        },
        minimizeWebRtc: false,

        backgroundReports: [],
        backgroundReportShortcut: null,

        alarmActivity: false,
        alarmTrayFilter: null,
        issueTrayFilter: null,

        alarmModificationShortcut: null,
        pagingRuleShortcut: null,
        createIssueFromAlarmShortcut: null,
        editSiteFromAlarmShortcut: null,
        editSiteBookFromAlarmShortcut: null,

        alarmSnackbar: {
            active: false,
            alarms: []
        },
        alarmsList: [],
        alarmsPolling: false,
        alarmsNewBuffer: [],
        alarmsUpdateBuffer: [],

        issuesList: [],
        issuesPolling: false,
        issuesNewBuffer: [],
        issuesUpdateBuffer: [],

        socket: {
            connected: false,
            connectedStatusTimestamp: null,
            error: '',
            message: '',
            activeClients: [],
        },
        contactMessages: [],

        screenshotsDrawerOpen: false,
        screenshots: [],

        connectionSnackbar: {
            active: false,
            user: null,
            loggingIn: null
        },

        page_counters: {},
        userPageVerifyShortcut: false,
        tutorialsShortcut: null,
        refreshRequired: false,
        aiAnalyzerContext: null,
        aiAnalyzerGridAPI: null,
        showAIAnalyzer: false,
        inactivityMode: false
    },

    getters: {
        connectionStatusObj: state => {
            return {
                connectionStatus: (state.socket.connected && state.connectionInfo.webAppConnected && state.connectionInfo.telsasoftCloudConnected),
                webSocketConnected: state.socket.connected,
                webSocketConnectedTS: TELSA.moment(state.socket.connectedStatusTimestamp).format('MM-DD HH:mm:ss'),
                webAppConnected: state.connectionInfo.webAppConnected,
                webAppConnectedTS: TELSA.moment(state.connectionInfo.webAppConnectedTimestamp).format('MM-DD HH:mm:ss'),
                telsaServerConnected: state.connectionInfo.telsaServerConnected,
                telsaServerConnectedTS: TELSA.moment(state.connectionInfo.telsaServerConnectedTimestamp).format('MM-DD HH:mm:ss'),
                telsasoftCloudConnected: state.connectionInfo.telsasoftCloudConnected,
                telsasoftCloudConnectedTS: TELSA.moment(state.connectionInfo.telsasoftCloudConnectedTimestamp).format('MM-DD HH:mm:ss'),
            };
        },

        dialogIsActive: state => {
            return (state.confirmModal.show || state.broadcastMessage.show || state.pagingClientMessage.show)
        },

        fullscreenIsActive: state => {
            return (state.fullscreenElement != '#telsasoft-application');
        },

        backgroundReportCounts: state => {
            return {
                runningCount: state.backgroundReports.filter(br => br.running == true).length,
                completedCount: state.backgroundReports.filter(br => br.running == false && (br.reportResultParamsHash || br.reportResultFileName)).length,
            }
        },

        localLock: (state) => (lockName) => {
            if(state.lock && state.lock.lock_name == lockName) {
                return state.lock;
            }
            else if(state.secondaryLocks && state.secondaryLocks.length) {
                let lock =  state.secondaryLocks.find(l => l.lock_name == lockName) || null;
                return lock;
            }
            return null;
        },
    },

    mutations: {
        setAuthenticatingStatus(state, payload) {
            state.authenticating = payload;
        },

        setUser(state, payload) {
            state.user = payload;
        },

        setUserImage(state, data) {
            state.userImage = data;
        },

        // setBatchConfig(state, batchConfig) {
        //     state.batchConfig = batchConfig;
        // },

        setWebappSettings(state, payload) {
            state.batchConfig.webapp_settings = payload;
        },

        setConnectionInfo(state, connectionInfo) {
            connectionInfo.webAppConnectedTimestamp = TELSA.moment.tz(state.batchConfig.timezone);
            connectionInfo.telsaServerConnectedTimestamp = TELSA.moment.tz(state.batchConfig.timezone);
            connectionInfo.runningPingCheck = false;
            state.connectionInfo = connectionInfo;
        },

        setRunningPingCheckOn(state, payload) {
            state.connectionInfo.runningPingCheck = true;
        },

        setPingCheckResults(state, payload) {
            state.connectionInfo.runningPingCheck = false;
            if(payload.webAppConnected != state.connectionInfo.webAppConnected) {
                state.connectionInfo.webAppConnected = payload.webAppConnected;
                state.connectionInfo.webAppConnectedTimestamp = TELSA.moment.tz(state.batchConfig.timezone);
            }
            // if(payload.telsaServerConnected != state.connectionInfo.telsaServerConnected) {
            //     state.connectionInfo.telsaServerConnected = payload.webAppConnected;
            //     state.connectionInfo.telsaServerConnectedTimestamp = TELSA.moment();
            // }
            if(payload.telsasoftCloudConnected != state.connectionInfo.telsasoftCloudConnected) {
                state.connectionInfo.telsasoftCloudConnected = payload.telsasoftCloudConnected;
                state.connectionInfo.telsasoftCloudConnectedTimestamp = TELSA.moment.tz(state.batchConfig.timezone);
            }
        },

        setLock(state, lock) {
            if(state.lock) {
                // Trying to set a lock when we already have a primary lock. So we shuold create a secondary lock.
                state.secondaryLocks.push(lock);
            }
            else if(lock) {
                // They're setting the primary lock because we dont already have a lock
                state.lock = lock;
            }
        },

        clearLock(state, lock) {
            if(state.lock.lock_name == lock.lock_name) {
                state.lock = null;
            }
            else {
                // clear a secondary lock
                let index = state.secondaryLocks.findIndex(l => l.lock_name == lock.lock_name);
                state.secondaryLocks.splice(index, 1);
            }
        },

        showConfirmModal(state, payload) {
            state.confirmModal.show = true;
            state.confirmModal.type = payload.type ? payload.type : '';
            state.confirmModal.title = payload.title;
            state.confirmModal.message = payload.message;
            state.confirmModal.confirmAction = payload.confirmAction;
            state.confirmModal.hideCancel = payload.hideCancel ? payload.hideCancel : false;
            state.confirmModal.cancelAction = payload.cancelAction ? payload.cancelAction : function(){};
        },
        closeConfirmModal(state) {
            state.confirmModal.show = false;
            state.confirmModal.type = '';
            state.confirmModal.title = '';
            state.confirmModal.message = '';
            state.confirmModal.confirmAction = '';
            state.confirmModal.hideCancel = false;
        },

        setFullscreenElement(state, payload) {
            state.fullscreenElement = payload ? payload : '#telsasoft-application';
        },

        closeBroadcastgModal(state) {
            state.broadcastMessage.show = false;
        },

        setTelsasoftAbout(state, payload) {
            state.telsasoftAbout = payload;
        },

        closePagingClientDialog(state) {
            state.pagingClientMessage.show = false;
        },

        openWikiHelp(state, route) {
            // Let's actually open the wiki in a new tab, rather than a modal window(iframe)
            // state.wikiHelp.route = route;
            // state.wikiHelp.show = true;
            window.open(`${state.wikiHelp.domain}${route}?accessKey=${state.wikiHelp.accessKey}`, '_blank');
        },
        closeWikiHelp(state) {
            state.wikiHelp.show = false;
        },
        
        setIsDirty(state, payload) {
            state.isDirty = payload;
        },

        setMessagingDrawerOpen(state, payload) {
            state.messagingDrawerOpen = payload;
            if(!payload) {
                state.messagingDrawerActiveContact = null;
            }
        },
        setMessagingDrawerActiveContact(state, payload) {
            state.messagingDrawerActiveContact = payload;
        },

        setAlarmsList(state, payload) {
            state.alarmsList = payload;
        },
        setAlarmsPolling(state, payload) {
            state.alarmsPolling = payload;
        },
        clearAlarmBuffers(state, payload) {
            state.alarmsNewBuffer = [];
            state.alarmsUpdateBuffer = [];
        },

        setIssuesList(state, payload) {
            state.issuesList = payload;
        },
        setIssuesPolling(state, payload) {
            state.issuesPolling = payload;
        },
        clearIssuesBuffers(state, payload) {
            state.issuesNewBuffer = [];
            state.issuesUpdateBuffer = [];
        },

        setAlarmSnackbar(state, payload) {
            state.alarmSnackbar.alarms = payload;
        },

        setAlarmTrayFilter(state, payload) {
            state.alarmTrayFilter = payload;
        },

        setIssueTrayFilter(state, payload) {
            state.issueTrayFilter = payload;
        },

        setAlarmModificationShortcut(state, alarm) {
            state.alarmModificationShortcut = alarm;
        },
        setPagingRuleShortcut(state, alarm) {
            state.pagingRuleShortcut = alarm;
        },
        setCreateIssueFromAlarmShortcut(state, alarm) {
            state.createIssueFromAlarmShortcut = alarm;
        },
        setEditSiteFromAlarmShortcut(state, alarm) {
            state.editSiteFromAlarmShortcut = alarm;
        },
        setEditSiteBookFromAlarmShortcut(state, site) {
            state.editSiteBookFromAlarmShortcut = site;
        },

        addAudioFileMeta(state, audioFileMeta) {
            state.audioFiles.push(audioFileMeta);
        },
        updateAudioFileMeta(state, audioFileMeta) { //used for upload progress
            let index = state.audioFiles.findIndex(a => {
                return a.name == audioFileMeta.name;
            });
            state.audioFiles[index] = audioFileMeta;
        },
        deleteAudioFileMeta(state, audioFileName) {
            let index = state.audioFiles.findIndex(a => {
                return a.name == audioFileName;
            });
            state.audioFiles.splice(index, 1);
        },
        clearStoreData(state, payload) {
            state.audioFiles = [];
            state.audioPlayQueue = [];
            state.contactMessages = [];
        },
        advanceAudioQueue(state, payload) {
            state.audioPlayData = null; // This is needed to make repeating playbacks of the same sound work
            state.audioPlayQueue.shift();
        },
        setAudioPlayData(state, data) {
            state.audioPlayData = data;
        },

        setWebRtc(state, payload) {
            state.webRtc = payload;
        },
        setMinimizeWebRtc(state, payload) {
            state.minimizeWebRtc = payload;
        },

        insufficientPermissions(state, payload) {
            state.confirmModal.show = true;
            state.confirmModal.type = 'warning';
            state.confirmModal.title = 'Permission Warning';
            state.confirmModal.message = payload.message ? payload.message : 'You do not have permission to save changes in this function.';
            state.confirmModal.confirmAction = payload.confirmAction ? payload.confirmAction : function(){};
            state.confirmModal.hideCancel = true;
        },

        displayTableauCreds(state, display) {
            state.batchConfig.tableau.displayCreds = display;
        },

        setScreenshotsDrawerOpen(state, payload) {
            state.screenshotsDrawerOpen = payload;
        },
        addScreenshot(state, screenshot) {
            state.screenshots.push(screenshot);
        },
        deleteScreenshot(state, screenshot) {
            state.screenshots.splice(state.screenshots.indexOf(screenshot), 1);
        },

        closeConnectionSnackbar(state, payload) {
            state.connectionSnackbar.active = false;
        },

        addBackgroundReport(state, payload) {
            state.backgroundReports.push(payload);
        },
        updateBackgroundReport(state, payload) {
            let backgroundReport = state.backgroundReports.find(br => br.timeId == payload.timeId);
            if(backgroundReport) {
                backgroundReport = payload;
            }
        },
        setBackgroundReportShortcut(state, payload) {
            state.backgroundReportShortcut = payload;
        },
        clearBackgroundReportShortcut(state, payload) {
            state.backgroundReportShortcut = null;
        },

        setUserPageVerifyShortcut(state, payload) {
            state.userPageVerifyShortcut = payload;
        },
        setTutorialsShortcut(state, payload) {
            state.tutorialsShortcut = payload;
        },
        setExpressReady(state, payload) {
            state.expressReady = payload;
        },
        setAiAnalyzerContext(state, payload) {
            state.aiAnalyzerContext = payload;
        },
        setAiAnalyzerGridAPI(state, payload) {
            state.aiAnalyzerGridAPI = payload;
        },
        setShowAIAnalyzer(state, payload) {
            state.showAIAnalyzer = payload;
        },
        setInactivityMode(state, payload) {
            state.inactivityMode = payload;
        },

        lostLock(state, payload) {
            this.commit('showConfirmModal', {
                title: 'Lost Lock',
                message: `The lock for this resource wasn't able to renew. Operation will fail.`,
                type: 'error',
                hideCancel: true,
                confirmAction: function(){}
            });
        },

        SOCKET_connect(state, sid) {
            state.socket.connected = true;
            state.socket.connectedStatusTimestamp = TELSA.moment.tz(state.batchConfig.timezone);
        },
        SOCKET_disconnect(state) {
            state.socket.connected = false;
            state.socket.connectedStatusTimestamp = TELSA.moment.tz(state.batchConfig.timezone);
        },

        SOCKET_ACTIVE_CLIENTS(state, clientList) {
            let userIsNew = (state.socket.activeClients.length < clientList.length);
            let connectionSnackbarUser;
            
            // Make sure we have a stable WS connection and that connection snackbar feature is enabled
            if(this._vm.$socket.id && true) {
                if(userIsNew) {
                    connectionSnackbarUser = clientList[clientList.length - 1];
                }
                else {
                    connectionSnackbarUser = state.socket.activeClients.find(ac => {
                        return clientList.every(c => {
                            return c.sid != ac.sid;
                        });
                    });
                }

                // Make sure the new user is not ourself.
                if(this._vm.$socket.id != connectionSnackbarUser.sid) {
                    state.connectionSnackbar = {
                        active: true,
                        user: connectionSnackbarUser,
                        loggingIn: userIsNew
                    }
                }
            }

            state.socket.activeClients = clientList;
        },

        SOCKET_MESSAGE(state, message) {
            let contactSeenBefore = false;
            let senderId = message.sender.user_id;
            message.own = (senderId == state.user.user_id);
            message.unread = message.own ? false : true;
            let contactUserId = (message.own ? message.recipient.user_id : message.sender.user_id);
            let contactUsername = (message.own ? message.recipient.user_username : message.sender.user_username);
            for(let contact of state.contactMessages) {
                if(contact.userId == contactUserId) {
                    contact.messages.push(message);
                    contactSeenBefore = true;
                }
            }
            // If we haven't chatted this contact before(it wasn't found in the state lists above) then lets add them to state list.
            if(!contactSeenBefore) {
                state.contactMessages.push({
                    userId: contactUserId,
                    username: contactUsername,
                    messages: [message]
                });
            }

            // Handle Sounds
            let sounds = state.batchConfig.webapp_settings.sounds;
            let chatMessageAudioFile = sounds.newChatMessageSoundActive ? sounds.newChatMessageSound : null;
            if(chatMessageAudioFile && !message.own && message.unread && (!state.messagingDrawerActiveContact || (state.messagingDrawerActiveContact.user_id != contactUserId))) {
                state.audioPlayQueue.push(chatMessageAudioFile);
            }
        },
        SOCKET_BROADCAST(state, payload) {
            let sounds = state.batchConfig.webapp_settings.sounds;
            let broadcastAudioFile = sounds.broadcastSoundActive ? sounds.broadcastSound : null;
            if(broadcastAudioFile) {
                state.audioPlayQueue.push(broadcastAudioFile);
            }
            
            let timestamp = TELSA.moment(payload.time).format("MMM DD YYYY hh:mm:ss A");
            state.broadcastMessage.time = timestamp;
            state.broadcastMessage.from = payload.from;
            state.broadcastMessage.message = payload.message;
            state.broadcastMessage.show = true;
            state.broadcastMessage.messageHistory.push({
                sender: payload.from,
                timestamp: timestamp,
                message: payload.message
            });
        },








        SOCKET_ALARM_ACTIVITY(state, payload) {
            // If they have no alarms product permissions then we ignore all alarm functionality
            if(state.user && state.user.navigation_permissions && !state.user.navigation_permissions.alarms) {
                return;
            }
            state.alarmActivity = payload;
        },

        SOCKET_ALARMS_NEW(state, payload) {
            // If they have no alarms product permissions then we ignore all alarm functionality
            if(state.user && state.user.navigation_permissions && !state.user.navigation_permissions.alarms) {
                return;
            }
            let newAlarms = payload;
            // If we are currently making an api request to get all the alarms
            // then we need to buffer new ones and apply them after the api call returns
            if(state.alarmsPolling) {
                state.alarmsNewBuffer = state.alarmsNewBuffer.concat(newAlarms);
            }

            // Setup to handle Sounds
            let sounds = state.batchConfig.webapp_settings.sounds;
            let criticalAlarmAudioFile = sounds.criticalAlarmSoundActive ? sounds.criticalAlarmSound : null;
            let majorAlarmAudioFile = sounds.majorAlarmSoundActive ? sounds.majorAlarmSound : null;
            let minorlAlarmAudioFile = sounds.minorAlarmSoundActive ? sounds.minorAlarmSound : null;
            let observationalAlarmAudioFile = sounds.observationalAlarmSoundActive ? sounds.observationalAlarmSound : null;
            for(let newAlarm of newAlarms) {
                // Handle Sounds
                if(newAlarm.alarm_severity == 'CRITICAL' && criticalAlarmAudioFile) {
                    state.audioPlayQueue.push(criticalAlarmAudioFile);
                }
                else if(newAlarm.alarm_severity == 'MAJOR' && majorAlarmAudioFile) {
                    state.audioPlayQueue.push(majorAlarmAudioFile);
                }
                else if(newAlarm.alarm_severity == 'MINOR' && minorlAlarmAudioFile) {
                    state.audioPlayQueue.push(minorlAlarmAudioFile);
                }
                else if(newAlarm.alarm_severity == 'OBSERVATIONAL' && observationalAlarmAudioFile) {
                    state.audioPlayQueue.push(observationalAlarmAudioFile);
                }
            }

            
            // Check thru the list of newAlarms to see if any are duplicates(same "alarm_key_str") of each other.
            // We turn the list of alarms into a list of groups of alarms by alarm_key_str. Then for each group we take 
            // the alarm that has the highest repeat count(most recent alarm of that group) and add it to the newAlarms list.
            let newAlarmsCombined = [];
            let alarmKeyStrGroups = _.groupBy(newAlarms, a => {
                return a.alarm_key_str;
            });
            for(let agKey in alarmKeyStrGroups) {
                let agList = alarmKeyStrGroups[agKey];
                newAlarmsCombined.push(agList.reduce((prev, current) => {return (prev.alarm_repeats > current.alarm_repeats ? prev : current)}));
            }
            //newAlarms = newAlarmsCombined;


            let actualNewAlarms = [];
            let actuallyNew;
            for(let newAlarm of newAlarmsCombined) {
                actuallyNew = true;
                for(let [i, alarm] of state.alarmsList.entries()) {
                    // Including check for alarm_id as a failsafe to avoid ever having 2 or more grid rows with the same id(alarm_id). If that were to happen its real bad.
                    if((newAlarm.alarm_id == alarm.alarm_id) || (newAlarm.alarm_key_str == alarm.alarm_key_str)) {
                            // Found a match so reset the old one to new one. This takes care of "Rep"    
                            state.alarmsList[i] = newAlarm;
                            actuallyNew = false;
                            break;
                    }
                }
                if(actuallyNew) {
                    actualNewAlarms.push(newAlarm);
                }
            }
            state.alarmsList = state.alarmsList.concat(actualNewAlarms);


            // Build alarm snackbar.
            if(state.batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarEnabled) {
                newAlarms.forEach(alarm => {
                    if((alarm.alarm_severity.toLowerCase() == 'critical' && state.batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarCriticalEnabled) 
                        || (alarm.alarm_severity.toLowerCase() == 'major' && state.batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarMajorEnabled)
                        || (alarm.alarm_severity.toLowerCase() == 'minor' && state.batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarMinorEnabled)
                        || (alarm.alarm_severity.toLowerCase() == 'observational' && state.batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarObservationalEnabled)) {
                        state.alarmSnackbar.alarms.push({
                            alarm_id: alarm.alarm_id,
                            color: state.batchConfig.webapp_settings.alarms.alarmColors[alarm.alarm_severity.toLowerCase()].new.background,
                            severity: alarm.alarm_severity,
                            office: alarm.alarm_office,
                            location: alarm.alarm_location,
                            description: alarm.alarm_description
                        });
                    }
                });
                state.alarmSnackbar.active = true;
            }
        },

        SOCKET_ALARMS_UPDATE(state, payload) {
            // If they have no alarms product permissions then we ignore all alarm functionality
            if(state.user && state.user.navigation_permissions && !state.user.navigation_permissions.alarms) {
                return;
            }

            // If we are currently making an api request to get all the alarms
            // then we need to buffer updates and apply them after the api call returns
            if(state.alarmsPolling) {
                state.alarmsUpdateBuffer = state.alarmsUpdateBuffer.concat(payload);
            }

            let found = false;
            for(let updatedAlarm of payload) {
                found = false;
                for(let [i, alarm] of state.alarmsList.entries()) {
                    if(updatedAlarm.alarm_id == alarm.alarm_id) {
                        state.alarmsList[i] = updatedAlarm;
                        found = true;
                        break;
                    }
                }
                if(!found) {
                    // This alarm wasn't found in the current alarms list. Check if it was recently un-cleared. If so, then add it. If not then do nothing.
                    if(updatedAlarm.alarm_history && updatedAlarm.alarm_history.length && updatedAlarm.alarm_history[0].includes('uncleared')) {
                        // Most recent action was an unclear. Let's add it.
                        state.alarmsList.push(updatedAlarm);
                    }
                }
            }

            // Remove the cleared alarms
            state.alarmsList = state.alarmsList.filter(alarm => {
                return !alarm.alarm_clear_time;
            });
        },








        SOCKET_ISSUES_NEW(state, payload) {
            // If they have no issues product permissions then we ignore all issues functionality
            if(state.user && state.user.navigation_permissions && !state.user.navigation_permissions.issues) {
                return;
            }
            let newIssues = payload;

            // If we are currently making an api request to get all the issues
            // then we need to buffer new ones and apply them after the api call returns
            if(state.issuesPolling) {
                state.issuesNewBuffer = state.issuesNewBuffer.concat(newIssues);
            }

            for(let newIssue of newIssues) {
                if(!newIssue.issue_close_time) {
                    // Check to make sure that the newIssue is not closed.
                    state.issuesList.push(newIssue);
                }
            }
        },
        SOCKET_ISSUES_UPDATE(state, payload) {
            // If they have no issues product permissions then we ignore all issues functionality
            if(state.user && state.user.navigation_permissions && !state.user.navigation_permissions.issues) {
                return;
            }

            // If we are currently making an api request to get all the issues
            // then we need to buffer updates and apply them after the api call returns
            if(state.issuesPolling) {
                state.issuesUpdateBuffer = state.issuesUpdateBuffer.concat(payload);
            }

            let found = false;
            for(let updatedIssue of payload) {
                found = false;
                for(let [i, issue] of state.issuesList.entries()) {
                    if(updatedIssue.issue_id == issue.issue_id) {
                        found = true;
                        // Need to check if the new one has been closed. If it has, then we need to check when it was closed in relation to the "Days Closed" value
                        if(updatedIssue.issue_close_time) {
                            // This issue should be removed because it's been closed
                            state.issuesList.splice(i, 1);
                        }
                        else {
                            state.issuesList[i] = updatedIssue;
                        }
                        break;
                    }
                }
                if(!found) {
                    // The only way the updated issue would not be found is if it was originally closed but now has been reopened. So we just add it like we would with a new issue.
                    state.issuesList.push(updatedIssue);
                }
            }
        },

        SOCKET_ERROR(state, message) {
            state.error = message.error
        },

        SOCKET_PAGING_NOTICE(state, payload) {
            state.pagingClientMessage.time = TELSA.moment.tz(state.batchConfig.timezone).format('MMM Do YYYY, hh:mm:ss a');
            state.pagingClientMessage.message = payload;
            state.pagingClientMessage.show = true;
        },

        SOCKET_PAGING_AUDIO(state, audioFileName) {
            state.audioPlayQueue.push(audioFileName);
        },

        SOCKET_KICKOFF(state, sender) {
            state.messagingDrawerOpen = false;
            state.messagingDrawerActiveContact = null;
            state.confirmModal.show = true;
            state.confirmModal.type = 'warning';
            state.confirmModal.title = 'Logging Out';
            if(sender == 'password_changed') {
                state.confirmModal.message = `Account password and/or username has been changed. Please log back in with new password and/or username.`;
            }
            else {
                state.confirmModal.message = `You have been logged off by <b>${sender}</b>`;
            }
            state.confirmModal.confirmAction = () => {state.kickoff++;};
            state.confirmModal.hideCancel = true;
            setTimeout(() => {
                state.kickoff++;  
            }, 5000); // 5 Seconds
        },

        SOCKET_WEBRTC_INVITE(state, message) {
            // If the contact is already in the middle of a webrtc session then we want to ignore the new invite.
            // Probably want to return something useful to the caller to let them know that the person was busy.
            if(state.webRtc.show) {
                return;
            }

            state.webRtc.contact = state.batchConfig.users.find(u => {
                return u.user_id == message.from_user_id;
            });
            state.webRtc.contact.sid = message.from_sid;
            state.webRtc.outgoing = false;
            state.webRtc.incoming = true;
            state.webRtc.show = true;
        },

        SOCKET_INFO(state, info) {
            //console.log("got websocket info!", info);
        },

        SOCKET_PERMISSIONS(state, user_ids) {
            if(user_ids.includes(String(state.user.user_id))) {
                state.refreshRequired = true;
            }
        },

        SOCKET_PAGE_COUNTER(state, data) {
            for(let m of data.methods) {
                let mm = {M: "email", S: 'sms', W: 'whatsapp', T: 'telegram', A: 'audio', C: 'client_notification', H: 'teams', P: 'push_notification'}[m];
                if(state.page_counters[data.username]) {
                    state.page_counters[data.username][mm].push(data.ts);
                }
                else {
                    state.page_counters[data.username] = {email: [], sms: [], whatsapp: [], telegram: [], audio: [], client_notification: [], teams: [], push_notification: []};
                    Vue.set(state.page_counters, data.username, state.page_counters[data.username]);
                    state.page_counters[data.username][mm].push(data.ts);
                }
            }
        }
    },

    actions: {
        setBatchConfig(context, batchConfig) {
            if(!batchConfig.webapp_settings || _.isEmpty(batchConfig.webapp_settings)) {
                // This means that this is the very first login from sys user. We need to set the default webapp settings
                // and then we should immediatley save these settings. All other non-sys users will get the fallback-to-sys-settings
                // whenever they log in, up until they manually save their own settings from the settings page.
                batchConfig.webapp_settings = defaultBaseSettings;

                if(!context.state.expressMode) {
                    let route = (TELSA.apiHost + "settings/save");
                    let settingsStr = JSON.stringify(batchConfig.webapp_settings);
                    Vue.http.post(route, {args: {webapp_settings: settingsStr}}).then(response => {
                        let result = response.body;
                    });
                }
            }
            // Here is where we place checks to verify that any "new" feature that requires default settings are present on 
            // the webapp_settings object. If the new feature settings are not found then we set them from the default.
            // Ex: if(!batchConfig.webapp_settings.newFeature) { batchConfig.webapp_settings.newFeature = defaultBaseSettings.newFeature; }
            if(!batchConfig.webapp_settings.preferences) { batchConfig.webapp_settings.preferences = defaultBaseSettings.preferences; }
            if(batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarCriticalEnabled == undefined) { batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarCriticalEnabled = defaultBaseSettings.alarms.alarmSnackbar.alarmSnackbarCriticalEnabled; }
            if(batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarMajorEnabled == undefined) { batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarMajorEnabled = defaultBaseSettings.alarms.alarmSnackbar.alarmSnackbarMajorEnabled; }
            if(batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarMinorEnabled == undefined) { batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarMinorEnabled = defaultBaseSettings.alarms.alarmSnackbar.alarmSnackbarMinorEnabled; }
            if(batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarObservationalEnabled == undefined) { batchConfig.webapp_settings.alarms.alarmSnackbar.alarmSnackbarObservationalEnabled = defaultBaseSettings.alarms.alarmSnackbar.alarmSnackbarObservationalEnabled; }
            if(batchConfig.webapp_settings.alarms.pagingEmailTemplate == undefined) { batchConfig.webapp_settings.alarms.pagingEmailTemplate = defaultBaseSettings.alarms.pagingEmailTemplate; }

            if(batchConfig.webapp_settings.preferences.thinScrollbar == undefined) { batchConfig.webapp_settings.preferences.thinScrollbar = defaultBaseSettings.preferences.thinScrollbar; }
            if(batchConfig.webapp_settings.preferences.inactivityTimeoutMin == undefined) {batchConfig.webapp_settings.preferences.inactivityTimeoutMin = defaultBaseSettings.preferences.inactivityTimeoutMin}

            if(batchConfig.webapp_settings.issues == undefined) { batchConfig.webapp_settings.issues = defaultBaseSettings.issues; }

            if(!batchConfig.webapp_settings.reports) { batchConfig.webapp_settings.reports = defaultBaseSettings.reports; }
            if(!batchConfig.webapp_settings.reports.chartColors) { batchConfig.webapp_settings.reports.chartColors = defaultBaseSettings.reports.chartColors; }
            if(batchConfig.webapp_settings.reports.allowRightClickEditChartColors == undefined) { batchConfig.webapp_settings.reports.allowRightClickEditChartColors = defaultBaseSettings.reports.allowRightClickEditChartColors; }
            if(batchConfig.webapp_settings.reports.metricCommonColor == undefined) { batchConfig.webapp_settings.reports.metricCommonColor = defaultBaseSettings.reports.metricCommonColor; }

            context.state.batchConfig = batchConfig;
        },

        getConfigItem(context, payload) {
            let route = `${TELSA.apiHost}settings/config/get`;
            return Vue.http.post(route, {args: {key: payload.key}}).then(response => {
                return response;
            });
        },
        setConfigItem(context, payload) {
            let route = `${TELSA.apiHost}settings/config/set`;
            return Vue.http.post(route, {args: {key: payload.key, value: payload.value}}).then(response => {
                return response;
            });
        },




        getCurrentAlarms(context, payload) {
            //console.log('refreshing alarms in store!!!!!!');
            let route = (TELSA.apiHost + "alarms/list");
            //TELSA.loading(true);
            context.commit('setAlarmsPolling', true);
            return Vue.http.get(route).then(response => {
                let alarmsList = response.body;
                context.commit('setAlarmsList', alarmsList);
                context.commit('setAlarmsPolling', false);

                // Apply the buffers now.
                //console.log('APPLY UPDATE BUFFER: ', context.state.alarmsUpdateBuffer);
                context.commit('SOCKET_ALARMS_NEW', context.state.alarmsNewBuffer);
                context.commit('SOCKET_ALARMS_UPDATE', context.state.alarmsUpdateBuffer);
                context.commit('clearAlarmBuffers');
                //TELSA.loading(false);
            });
        },

        getCurrentIssues(context, payload) {
            let route = (TELSA.apiHost + "issues/list");
            context.commit('setIssuesPolling', true);

            let daysClosed = 0;
            return Vue.http.post(route, {args: {daysClosed: daysClosed, getSites: true, getNetsuiteStatuses: context.state.batchConfig.webapp_netsuite}}).then(response => {
                let issuesList = response.body;
                console.log('GOT ISSUES LIST IN STORE: ', issuesList);
                context.commit('setIssuesList', issuesList);
                context.commit('setIssuesPolling', false);
                // Apply the buffers now.
                context.commit('SOCKET_ISSUES_NEW', context.state.issuesNewBuffer);
                context.commit('SOCKET_ISSUES_UPDATE', context.state.issuesUpdateBuffer);
                context.commit('clearIssuesBuffers');
            });  
        },




        handleRemoveLocks(context, lockName) {
            const route = `${TELSA.apiHost}locks/release`;
            if(lockName == 'ALL') {
                let locks = [];
                if(context.state.lock) {
                    locks.push(context.state.lock);
                }
                locks = context.state.secondaryLocks.concat(locks);
                let promises = [];
                for(let lock of locks) {
                    context.commit('clearLock', lock);
                    promises.push(Vue.http.post(route, {args: {lock: lock}}));
                    Promise.all(promises).then(res => {
                        TELSA.loading(false);
                    });

                }
            }

            else if(context.state.lock) {
                TELSA.loading(true);
                const lock = context.state.secondaryLocks.find(l => l.lock_name == lockName) || context.state.lock;
                context.commit('clearLock', lock);
                return Vue.http.post(route, {args: {lock: lock}}).then(response => {
                    let results = response.body;
                    TELSA.loading(false);
                });
            }
        },

        getLock(context, lockName) {
            TELSA.loading(true);
            const route = `${TELSA.apiHost}locks/acquire`;
            return Vue.http.post(route, {args: {lockName: lockName}}).then(response => {
                let results = response.body;
                let lock = JSON.parse(results.data);
                if(lock.lock_username) {
                    // Someone else has already locked this page.
                    return lock.lock_username;
                }
                else {
                    // We got the lock!
                    lock.client_exp = TELSA.moment().unix() + 3600; // 1 hour greedy lock
                    context.commit('setLock', JSON.parse(JSON.stringify(lock)));
                    return false;
                }
            });
        },

        refreshLock(context, payload) {
            if(context.state.lock) {
                // We have a current lock. Let's refresh it.
                const route = `${TELSA.apiHost}locks/renew`;
                let all_locks = [context.state.lock].concat(context.state.secondaryLocks);
                for(let [idx, lock] of all_locks.entries()) {
                    // Check if they have had the same lock for a LONG time
                    if(TELSA.moment().unix() > lock.client_exp) {
                        console.log('Greedy Lock!');
                        context.commit('lostLock');
                        break;
                    }
                    Vue.http.post(route, {args: {lock: lock}}).then(response => {
                        let result = response.body;

                        if(idx === 0) {
                            console.log('LOCK REFRESH: ', result);
                        }
                        else {
                            console.log('2nd LOCK REFRESH: ', result);
                        }

                        if(result == "failure") {
                            context.commit('lostLock');
                        }
                    });
                }
            }
        },







        sendBroadcast(context, payload) {
            let route = (TELSA.apiHost + "broadcast");
            return Vue.http.post(route, {args: {message: payload}}).then(response => {
                let result = response.body;
            });
        },

        getUserImages(context, payload) {
            let users = context.state.batchConfig.users;
            let currentUserId = context.state.user.user_id;

            let route = (`${TELSA.apiHost}users/imageall`);
            Vue.http.get(route).then(response => {
                let userImages = response.body;
                for(let userImage of userImages) {
                    for(let user of users) {
                        if(userImage.user_id == user.user_id) {
                            user.userImage = userImage.image;
                        }
                    }
                }
            });

            // for(let user of users) {
            //     if(user.user_id != currentUserId) {
            //         let route = (`${TELSA.apiHost}users/image/${user.user_username}`);
            //         Vue.http.get(route).then(response => {
            //             let result = response.body;
            //             if(result) {
            //                 user.userImage = result;
            //             }
            //         });
            //     }
            // }
        },

        getAudioFileList(context, payload) {
            let route = `${TELSA.apiHost}settings/audiofilelist`;
            return Vue.http.get(route).then(response => {
                let serverAudioFileMetas = response.body;
                let getList = [];
                // Initialize to flag all server files for needed to get
                serverAudioFileMetas.forEach(s => {
                    getList.push(s.name);
                });
                let deleteList = [];
                TELSA.IDB.getAll('audioFileStore').then(response => {
                    let idbAudioFiles = response;
                    // Initialize to flag all idb files for needed to delete
                    idbAudioFiles.forEach(i => {
                        deleteList.push(i.name);
                    });

                    // Now check the server list against the indexedDB list. Unflag items from get/delete as matched are found.
                    for(let serverAudioFileMeta of serverAudioFileMetas) {
                        for(let idbAudioFile of idbAudioFiles) {
                            if((serverAudioFileMeta.name == idbAudioFile.name) && (serverAudioFileMeta.hash == idbAudioFile.hash)) {
                                // We have the file already so we don't need to get it and we shouldn't delete it.
                                getList.splice(getList.indexOf(serverAudioFileMeta.name), 1);
                                deleteList.splice(deleteList.indexOf(serverAudioFileMeta.name), 1);
                                context.commit('addAudioFileMeta', serverAudioFileMeta);
                                break;
                            }
                        }
                    }

                    // Now we need to retrieve all the files still flagged for "get", then also delete the files locally still flagged for "delete"
                    let route = `${TELSA.apiHost}settings/audiofilelist`;
                    for(let audioFileName of getList) {
                        let route = `${TELSA.apiHost}settings/audiofile/${audioFileName}`;
                        Vue.http.get(route).then(response => {
                            let audioFile = response.body;
                            TELSA.IDB.set('audioFileStore', audioFile.name, audioFile).then(response => {});
                            let audioFileMeta = {
                                name: audioFile.name,
                                type: audioFile.type,
                                size: audioFile.size,
                                hash: audioFile.hash,
                            }
                            context.commit('addAudioFileMeta', audioFileMeta);
                        });
                    }
                    for(let audioFileName of deleteList) {
                        TELSA.IDB.remove('audioFileStore', audioFileName).then(response => {});
                    }

                });
            });
        },

        addAudioFile(context, audioFileObj) {
            let hash = hashLib({name: audioFileObj.name, type: audioFileObj.type, size: audioFileObj.size, data: audioFileObj.data});
            let audioFileTransport = {
                name: audioFileObj.name,
                type: audioFileObj.type,
                size: audioFileObj.size,
                hash: hash,
                data: audioFileObj.data,
            };
            let audioFileMeta = {
                name: audioFileObj.name,
                type: audioFileObj.type,
                size: audioFileObj.size,
                hash: hash,
                uploading: true,
                uploadProgress: 0
            };
            context.commit('addAudioFileMeta', audioFileMeta);

            let route = `${TELSA.apiHost}settings/audiofile`;
            let httpPromise = Vue.http.post(route, {args: {audioFileObj: audioFileTransport}}, 
                {progress(e) {
                    let progress = Math.floor((e.loaded / e.total) * 100);
                    audioFileMeta.uploadProgress = progress;
                    context.commit('updateAudioFileMeta', audioFileMeta);
                }}).then(response => {
                    let results = response.body;
                    audioFileMeta.uploading = false;
                    context.commit('updateAudioFileMeta', audioFileMeta);
            });

            // Add file to indexedDB
            TELSA.IDB.set('audioFileStore', audioFileTransport.name, audioFileTransport).then(response => {
                let result = response;
            });
        },

        deleteAudioFile(context, audioFileName) {
            // Remove from store meta list
            context.commit('deleteAudioFileMeta', audioFileName);

            // Delete from server
            let route = `${TELSA.apiHost}settings/audiofiledelete`;
            let httpPromise = Vue.http.post(route, {args: {audioFileName: audioFileName}}).then(response => {
                let result = response.body;
            });

            // Remove file from indexedDB
            TELSA.IDB.remove('audioFileStore', audioFileName).then(response => {
                let result = response;
            });
        },

        getAudioFileData(context) {
            let audioFileName = context.state.audioPlayQueue[0];
            if(!audioFileName) {
                return;
            }
            TELSA.IDB.get('audioFileStore', audioFileName).then(response => {
                context.commit('setAudioPlayData', response.data);
            });
        },

        runReportInBackground(context, payload) {
            const route = `${TELSA.apiHost}report/run`;
            let timeId = Date.now();
            let reportObj = {
                reportParamObj: payload,
                timeId: timeId,
                reportResultParamsHash: null,
                running: true
            };
            context.commit('addBackgroundReport', reportObj);
            return Vue.http.post(route, {args: payload}).then(response => {
                let results = response.body;
                if(results == 'no_report') {
                    context.commit('showConfirmModal', {
                        type: 'error',
                        hideCancel: true,
                        title: 'Report Error',
                        message: 'Report not found.',
                        confirmAction: () => {context.commit('closeConfirmModal');}
                    });
                    reportObj.error = true;
                }
                else if(results.file_name) {
                    reportObj.reportResultFileName = results.file_name;
                    reportObj.reportResultPrettyFileName = results.pretty_file_name
                }
                else {
                    reportObj.reportResultParamsHash = results.data.params_hash;
                }
                reportObj.running = false;
                context.commit('updateBackgroundReport', reportObj);
            }, error => {
                reportObj.running = false;
                reportObj.error = true;
                context.commit('updateBackgroundReport', reportObj);
            });
        },

    }
})
